import _ from 'lodash'
// import dayjs from 'dayjs'
import openedApi from '@/api/opened'

const state = {
  sortType: 'OPENED_TIME_DESC', // NAME_ASC
  items: []
}

const getters = {
  items (state) {
    return getterItems(state.items)
  },
  isEmpty (state) {
    return state.items.length === 0
  },
  first (state, getters) {
    return last(getters.items)
  }
}

const mutations = {
  SET_ITEMS (state, items) {
    state.items = items
  },
  REMOVE (state, { notebookId, noteId }) {
    if (notebookId && !noteId) {
      _.remove(state.items, n => n.notebookId === notebookId)
      state.items = [...state.items]
    } else if (noteId) {
      _.remove(state.items, n => n.noteId === noteId)
      state.items = [...state.items]
    }
  },
  SET_NOTEBOOK_NAME (state, { notebookId, notebookName }) {
    const items = _.filter(state.items, n => n.notebookId === notebookId)
    for (let i = 0; i < items.length; i++) {
      items[i].notebookName = notebookName
    }
  },
  SET_NOTE_NAME (state, { noteId, noteName }) {
    const item = _.find(state.items, n => n.noteId === noteId)
    if (item) {
      item.noteName = noteName
    }
  }
}

const actions = {
  async add ({ commit }, { notebookId = '', noteId = '' }) {
    const openedList = await openedApi.add({ notebookId, noteId })
    commit('SET_ITEMS', openedList)
  },
  async load ({ commit }) {
    const openedList = await openedApi.query()
    commit('SET_ITEMS', openedList)
  },
  async loadLast ({ commit }) {
    const openedList = await openedApi.query()
    const items = getterItems(openedList)
    return last(items)
  },
  async remove ({ commit }, { notebookId = '', noteId = '' }) {
    if (notebookId !== '' && noteId === '') {
      await openedApi.removeByNotebookId(notebookId)
    } else if (noteId !== '') {
      await openedApi.removeByNoteId(noteId)
    }
    commit('REMOVE', { notebookId, noteId })
  },
  changeName ({ commit }, { type, notebookId, noteId, notebookName, noteName }) {
    if (type === 'NOTEBOOK') {
      commit('SET_NOTEBOOK_NAME', { notebookId, notebookName })
    } else if (type === 'NOTE') {
      commit('SET_NOTE_NAME', { noteId, noteName })
    }
  }
}

function getterItems (openedList) {
  const result = []
  openedList.forEach(n => {
    if (n.notebookId !== '') {
      let item = _.find(result, m => m.notebookId === n.notebookId)
      if (item === undefined) {
        item = {
          type: 'NOTEBOOK',
          notebookId: n.notebookId,
          notebookName: n.notebookName,
          noteId: '',
          noteName: '',
          openedTime: n.openedTime,
          notes: []
        }
        result.push(item)
      }
      if (n.noteId !== '') {
        item.notes.push({
          type: 'NOTE',
          notebookId: n.notebookId,
          notebookName: n.notebookName,
          noteId: n.noteId,
          noteName: n.noteName,
          openedTime: n.openedTime
        })
      }
    } else {
      result.push({
        type: 'NOTE',
        notebookId: '',
        notebookName: '',
        noteId: n.noteId,
        noteName: n.noteName,
        openedTime: n.openedTime
      })
    }
  })
  return result
}

function last (getterItems) {
  if (getterItems.length === 0) {
    return null
  }
  const item = getterItems[0]
  if (item.type === 'NOTE') {
    return item
  }
  if (item.notes.length > 0) {
    return item.notes[0]
  } else {
    return item
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
